<template>
  <v-app>
    <v-content class="primary">
      <v-container fluid fill-height>
        <slot />
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {}
</script>
